<template>
  <div class="seoWeb">
    <div class="seoWeb_item"
         @click="skipMarketingWeb()">我的营销网址</div>
    <div class="seoWeb_item"
         @click="skipMarketingWebList()">下级网址管理</div>
    <!-- <div class="seoWeb_item">推广详情</div> -->
  </div>

</template>

<script>
export default {
  name: 'seoWeb',
  methods: {
    skipMarketingWeb () {
      this.$router.push({
        name: 'Marketing',

      })
    },
    skipMarketingWebList () {
      this.$router.push({
        name: 'manage_web',
      })
    }
  }
}
</script>

<style lang='scss'>
.seoWeb {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .seoWeb_item:hover {
    background-color: #515257 !important;
    box-shadow: 0 0 10px 1px #28292f;
  }
  .seoWeb_item {
    margin: 10px;
    cursor: pointer;
    // width: 100px;
    padding: 0 20px;
    height: 50px;
    background-color: #28292f;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    transition: all 0.3s;
    // border: 1px solid #999;
    border-radius: 10px;
    box-shadow: 0 0 5px 1px #28292f;
    letter-spacing: 5px;
    font-weight: 700;
    font-size: 18px;
  }
}
</style>